import React from 'react';
import HeaderContent from 'components/common/HeaderContent/HeaderContent';
import { ProductCardOnCart } from 'components/Product';
import { formatPrice } from 'utils';
// import StickySidebarLayout from 'components/common/StickySidebarLayoutProps/StickySidebarLayoutProps';
import { SupplierOrderCartProps } from 'types';
import { InputCommon } from 'components/common';
import { Checkbox } from 'antd';

const SupplierOrderCart: React.FC<SupplierOrderCartProps> = ({
  products,
  totalQuantity,
  totalPrice,
  vat,
  setVat,
  initQuantity,
  handleCheckAll,
}) => {
  return (
    // <StickySidebarLayout top={0}>
    <div className='w-full h-full flex flex-col'>
      <HeaderContent
        key='cartSupplier'
        size='sm'
        label='Giỏ hàng'
        contentHeader='Sản phẩm đã thêm của bạn được hiển thị tại đây'
        className='rounded-none shadow-none'
      />
      <div className='p-6 bg-[var(--bgBlackOpacity5)] h-[calc(100vh-290px)]  overflow-y-auto  w-[444px]'>
        <div className='flex flex-col gap-4'>
          {products.map((product) => (
            <ProductCardOnCart key={product.id} product={product} />
          ))}
        </div>
      </div>
      <div className='p-6 py-2 text-[var(--textBlack56)] bg-white'>
        <p className='leading-6 flex items-center'>
          <span className='min-w-[120px]'>Số lượng:</span>{' '}
          <span className='font-medium text-black'>
            {totalQuantity}
            {<span className='ml-1.5'>{initQuantity !== 0 && initQuantity ? '/' + initQuantity : ''}</span>}
          </span>
        </p>
        {initQuantity !== 0 && initQuantity && (
          <>
            <div className='leading-6 flex items-center my-2'>
              <Checkbox checked={initQuantity <= totalQuantity} onChange={handleCheckAll} />
              <span className='font-normal text-black ml-2'>{'Trả tất cả sản phẩm'}</span>
            </div>
          </>
        )}
        {!vat && <div className='border-b my-2 border-[var(--textBlack4)]'></div>}

        <p className='font-bold text-base leading-8 flex items-center '>
          <span className='min-w-[120px]'>Tạm tính:</span> <span className='text-black'>{formatPrice(totalPrice)}</span>{' '}
          <span className='ml-2'> VND</span>
        </p>

        {vat !== undefined && (
          <>
            <div className='border-b my-2 border-[var(--textBlack4)]'></div>
            <p className='leading-6 flex items-center'>
              <span className='min-w-[120px]'>VAT %:</span>{' '}
              <InputCommon
                type='number'
                hardSize='sm'
                placeholder='Nhập giá trị'
                className='flex-1 max-w-[80px]'
                onChange={(e) => (setVat ? setVat(Number(e.target.value)) : null)}
                value={vat}
                min={0}
                max={100}
              />
            </p>
            <p className='font-bold text-base leading-8 flex mt-1 items-center text-[var(--primaryColor500)]'>
              <span className='min-w-[120px]'>Tổng:</span>{' '}
              <span className=''>{formatPrice(totalPrice + (totalPrice * (vat || 0)) / 100)}</span>
              <span className='ml-2 opacity-50'> VND</span>
            </p>
          </>
        )}
      </div>
    </div>
    // </StickySidebarLayout>
  );
};

export default SupplierOrderCart;
